/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Two_Factor_Already_EnabledInputs */

const nl_auth_api_errors_two_factor_already_enabled = /** @type {(inputs: Auth_Api_Errors_Two_Factor_Already_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee-factor authenticatie is al ingeschakeld`)
};

/**

* @param {Auth_Api_Errors_Two_Factor_Already_EnabledInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_two_factor_already_enabled = /** @type {((inputs?: Auth_Api_Errors_Two_Factor_Already_EnabledInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Two_Factor_Already_EnabledInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_two_factor_already_enabled(inputs)
});
export { auth_api_errors_two_factor_already_enabled as "auth.api_errors.two_factor_already_enabled" }